import styled from 'styled-components';

export const StyledUserAdminLogin = styled.div`
  .login-wrapper {
    display: grid;
    grid-template-rows: 50px, [1fr], 50px;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: calc(100vh - 100px);

    > div {
      text-align: center;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    padding: 0 7%;
    width: 392px;
  }

  .ant-input {
    background: #f5f5f5;
    border-radius: 10px;
    margin-top: 10px;
    height: 45px;
  }

  .ant-btn {
    background: #2264ff;
    border-radius: 10px;
    height: 45px;
  }
`;
